export function isYoutubeLink(url: string) {
  const regex = /^(http(s)?:\/\/)?((w){3}.)?youtu(be|.be)?(\.com)?\/.+/;
  return regex.test(url);
}

export function isValidDownloadLink(url: string) {
  return extractInstagramReelShortcode(url) !== null || extractTikTokVideoId(url) !== null;
}

export function areFilesValid(files: FileList, acceptedTypes: string[], acceptedExtensions: string[] = []) {
  if (!files.length) {
    return false;
  }

  const normalizedAcceptedTypes = acceptedTypes.map(type => type.toLowerCase());
  const normalizedAcceptedExtensions = acceptedExtensions.map(extension => extension.toLowerCase());
  const filesList = Array.from(files);

  return filesList.every(file => {
    const normalizedType = file.type.split(";")[0]?.trim().toLowerCase();

    if (normalizedType && normalizedAcceptedTypes.includes(normalizedType)) {
      return true;
    }

    const fileNameParts = file.name.split(".");
    const fileExtension = fileNameParts.length > 1 ? `.${fileNameParts.pop()!.toLowerCase()}` : "";

    return !!fileExtension && normalizedAcceptedExtensions.includes(fileExtension);
  });
}

export function shouldValidateFileSelection(files: FileList | null | undefined): files is FileList {
  return Boolean(files?.length);
}

export function extractInstagramReelShortcode(fileUrl: string) {
  const match = fileUrl.match(/instagram\.com\/(?:reel|reels|p)\/([A-Za-z0-9_-]+)/);
  return match ? match[1] : null;
}

export function extractTikTokVideoId(fileUrl: string) {
  const match = fileUrl.match(/tiktok\.com\/.*\/video\/(\d+)/);
  return match ? match[1] : null;
}
